import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { EventService } from 'src/app/events/services/event.service';
import { MapAsideService } from '../../service/map-aside.service';
import { fromEvent, Observable, of, Subject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import {
  distinctUntilChanged,
  filter,
  map,
  switchMap,
  takeUntil,
  tap,
} from 'rxjs/operators';
import {
  ErrorMessage,
  EventContent,
  FormValidationResult,
  OptionDropdown,
  VALIDATION_MESSAGES,
  ValueInputsDisabled,
} from './models/event-content.model';
import {
  getContentPopup,
  getEventContent,
} from 'src/app/events/helpers/event-helper';
import { OperatorService } from 'src/app/shared/services/operator.service';
import {
  nommalizeLabels,
  normalizeArrayEvaluations,
} from './helpers/normalize-labels-evaluations';
import { EvaluationCriteriaService } from 'src/app/events/services/evaluation-criteria.service';
import { FormFieldValidators } from './helpers/form-field-validator';
import { clone, cloneDeep } from 'lodash';
import { AlertService } from 'src/app/alertas/services/alert.service';
import { WhatsappService } from 'src/app/events/services/whatsapp.service';
import { WhatsAppResponse } from 'src/app/events/models/interfaces';
import { formatTimeWithUnit } from './helpers/normalize-date';
import { VehicleService } from 'src/app/vehicles/services/vehicle.service';
import { GeofencesService } from 'src/app/geofences/services/geofences.service';
import { Driver } from 'src/app/drivers/models/interfaces';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';
import { DriversService } from 'src/app/drivers/services/drivers.service';
import {
  ChecklistEventService,
  Checklist,
} from 'src/app/events/services/checklist-event.service';

import {
  extractTemperatureAndHumidityData,
  extractSingleTemperatureAndHumidityData,
} from 'src/app/shared/helpers/extractTemperatureAndHumidityData';
import { MomentService } from 'src/app/vehicles/services/moment.service';
import { DriverIdentificationService } from 'src/app/drivers/driver-identification/services/driver-identification.service';
import { PermissionService } from 'src/app/permiss/permission.service';

interface ChecklistData {
  num_plate: string;
  code: string;
  code_driver: string;
  has_checklist: boolean;
  date_check: string;
  driver?: string;
  codigo_driver?: string;
}
interface ChecklistResponse {
  success: boolean;
  message: string;
  data: ChecklistData;
}

@Component({
  selector: 'app-events-content',
  templateUrl: './events-content.component.html',
  styleUrls: ['./events-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventsContentComponent
  implements OnInit, AfterViewInit, OnDestroy {
  public event$: Observable<any>;
  public auxDisabled$: Observable<boolean>;
  public errorServer$: Observable<boolean>;
  public valueInputsDisabled$: Observable<ValueInputsDisabled | null>;
  public isSecondCardActive: boolean = true;
  private destroy$ = new Subject<void>();
  private divContainer: any;
  private idEvent: string = '';
  private componentRef: any;
  public msmOfTxRadial: string = 'Sin Respuesta';
  public radioValue: boolean | null = null;
  public isCriteria: boolean = false;
  public isConfirmedEvaluation: boolean = false;
  public originRadioComunitacion: boolean | null = null;

  private criteriaEvaluations: OptionDropdown[] = [];
  private nameOperatorLocalStorage: string = '';
  public isLoading$: Observable<boolean>;

  public valueRaiting: number | null = null;
  public eventIdAux: any;
  public imeiBelongsToAntapaccayAccount: boolean = false;
  public confirmedJudgingEvent: boolean = false;
  public evaluationsAux: any;
  public senalesPosibleFatigaAux: any;

  @ViewChild('criteriaInput') criteriaInput!: ElementRef;
  @ViewChild('observationInput') observationInput?: ElementRef;
  private checklistSub?: Subscription;

  private auxDisabled: boolean = false;
  public isMaximized$: Observable<boolean>;

  private isMaximizedAux: boolean = false;
  public messagesSentByWhatsApp$: Observable<WhatsAppResponse[] | null>;
  public flagEventPopup: boolean = false;
  public checklistDetail: Checklist | undefined;
  public internalChecklist: any;
  public detailVelocityEvent: any;

  private originPopup: boolean = false;
  observations: string[] = [];
  public driver: string = '';
  public eventData: any;
  public get driversList(): Driver[] {
    return this.driversService.drivers || [];
  }
  public get driversWithKeyCipia(): Driver[] {
    return this.driversList;
  }

  public driverIdentificationId: number = 0;

  constructor(
    public eventService: EventService,
    private mapAsideService: MapAsideService,
    private evaluationCriteriaService: EvaluationCriteriaService,
    private alertService: AlertService,
    private whatsappService: WhatsappService,
    private cdr: ChangeDetectorRef,
    private vehicleService: VehicleService,
    private localStorageService: LocalStorageService,
    private checklistEventService: ChecklistEventService,
    private driversService: DriversService,
    private momentService: MomentService,
    private geofencesService: GeofencesService,
    private driverIdentificationService: DriverIdentificationService,
    private permissionService : PermissionService
  ) {
    this.event$ = this.mapAsideService.data$.pipe(
      filter((data) => {
        return !!data;
        /* if (data.flagEventPopup) {
          return !!data;
        }
        return !!data && !!data.evaluations; */
      }),
      switchMap((data: any) => {
        // aplicar un reset de inputs y variables
        this.clearForm();
        this.imeiBelongsToAntapaccayAccount = false;
        this.confirmedJudgingEvent = false;
        this.senalesPosibleFatigaAux = false;
        this.sendEvaluationByWhatsapp = false;
        this.sendExternal = false;
        this.isLoadingMessages = false;
        this.flagEventPopup = false;
        this.whatsappsSendingMessage = '';
        this.messagesSentByWhatsApp = [];

        return of(data);
      }),
      map((data: any) => {
        // MARCADOR RAFA, ponemos '==' porque el id puede venir string o number
        const drivers = this.driversService.drivers;
        const driverFound = drivers.find((d) => d.id == data.driver_id);
        let nameDriver = 'No identificado';
        if (driverFound) {
          nameDriver = driverFound.nombre_conductor ?? 'No identificado';
        }

        this.submitSendEvaluationByWhatsappEmitter();
        this.submitSendExternalEmitter();
        this.loadObservations();
        this.eventSelected = data;
        this.eventIdAux = data.evento_id;
        // filtrado de atributos en base al tipo de evento
        const filteredObject = getEventContent(data);
        this.criteriaEvaluations = data.evaluation_criteria_filter
          ? data.evaluation_criteria_filter
          : [];
        this.vehicleIsFromAntapaccay(data.imei);
        this.sendExternal = false;
        const evaluatios = data.evaluations ? data.evaluations : {};
        this.evaluationsAux = data.evaluations;
        this.variantMessage = 'default';
        this.keyboardNextAndPreviousSubscription$.next(true);
        if (data.flagEventPopup && data.flagEventPopup === true) {
          this.flagEventPopup = true;
        } else {
          this.keyboardNextAndPreviousSubscription$.next(false);
          this.setupKeyboardShortcutsNextAndPrevious();
        }

        if (data.originPopup && data.originPopup === true) {
          this.originPopup = true;
        } else {
          this.originPopup = false;
        }

        const evaluationsAux =
          data.evaluations &&
            Array.isArray(data.evaluations) &&
            data.evaluations.length > 0
            ? data.evaluations[0]
            : null;

        if (evaluationsAux) {
          this.messageSendingMessage(
            evaluationsAux.usuario_id,
            evaluationsAux.uuid_event
          );
        }
        return {
          ...filteredObject,
          mensaje_alerta: data.mensaje_alerta ?? undefined,
          componentRef: data.componentRef,
          parametros: data.parametros,
          name: data.name,
          nombre: data.nombre,
          tipo: data.tipo,
          evaluation_criteria_filter: data.evaluation_criteria_filter
            ? data.evaluation_criteria_filter
            : [],
          operators: data.operators ? nommalizeLabels(data.operators) : [],
          bol_evaluation: data.bol_evaluation,
          evaluations: Array.isArray(evaluatios)
            ? evaluatios[0]
            : evaluatios !== undefined
              ? evaluatios
              : {},
          driver_id : data.driver_id,
          name_driver:
            nameDriver === 'No identificado'
              ? nameDriver
              : nameDriver.toUpperCase(),
        };
      }),
      map((data: any) => {
        console.log('event slider show event content', data);
        this.idEvent = data.uuid_event;
        this.componentRef = data.componentRef;
        // Si tenemos componentRef, intentamos montar el componente
        if (this.componentRef) {
          this.tryMountComponent();
        }
        const state = data.evaluations.has_radio_communication;
        this.originRadioComunitacion = state;
        this.radioValue = state;
        this.msmOfTxRadial = this.msmOfTxRadialSelect(state);
        this.isCriteria = data.evaluation_criteria_filter.length > 0;
        this.nameOperatorLocalStorage =
          localStorage.getItem('monitoringOperator') || '';
        this.operator_name_input = this.nameOperatorLocalStorage;
        cdr.detectChanges();

        if (!this.auxDisabled) {
          setTimeout(() => {
            if (this.isCriteria && this.criteriaInput) {
              // Para p-dropdown, necesitamos acceder al elemento input interno
              const dropdownInput = (
                this.criteriaInput as any
              ).el.nativeElement.querySelector('input');
              if (dropdownInput) {
                dropdownInput.focus();
              }
            } else if (this.observationInput) {
              // Para input normal
              this.observationInput.nativeElement.focus();
            }
          });
        }

        this.handleComponentRefChange(data);

        this.eventData = data;

        this.driver =
          this.vehicleService.vehicles.find(
            (vh) => vh.IMEI == this.eventData.imei
          )?.namedriver ?? '';
        const statusCamera = this.getDescriptionCamera(
          data?.parametros?.eventAttr
        );
        const statusSystemError = this.getDescriptionSystemError(
          data?.parametros?.eventAttr
        );
        const statusSystemOk = this.getDescriptionSystemOk(
          data?.parametros?.eventAttr
        );
        const statusSystemBootFailure = this.getDescriptionSystemBootFailure(
          data?.parametros?.eventAttr
        );


        if (this.eventData && this.eventData.evento == 'checklist-daily') {
          this.checklistDetail = this.checklistEventService.getChecklistEvent(
            this.eventData.uuid_event
          );
          // console.log("event content : init value checklsit", this.checklistDetail)
        }


        if (this.eventData && this.eventData.evento == 'checklist-interno') {
          let checklist = typeof data.mensaje_alerta === 'string' ? JSON.parse(data.mensaje_alerta) : data.mensaje_alerta;
          console.log("event content : init value checklsit", checklist)
          this.internalChecklist = checklist;
        }

        if (this.eventData && this.eventData.evento == 'exceso-velocidad-duracion-direccion') {
          let detail = typeof data.mensaje_alerta === 'string' ? JSON.parse(data.mensaje_alerta) : data.mensaje_alerta;

          const frames: Array<{ dateTimes?: string }> = detail?.frame ?? [];

          const geo = detail.zone?.id ? this.geofencesService.getGeofenceById(detail.zone.id) : null;
          detail.geoMaxVel = geo.vel_max || null;
          console.log("event content : init value exceso-velocidad-duracion-direccion", detail)
          const getFecha = (dt?: string): string | null => {
            if (!dt) return null;
            let date = this.momentService.toLocal(dt, true)
            return date as string;
          };



          if (frames.length > 0) {
            detail.timeInit = getFecha(frames[0].dateTimes);
            detail.timeEnd = getFecha(frames[frames.length - 1].dateTimes);
          } else {
            detail.timeInit = null;
            detail.timeEnd = null;
          }

          this.detailVelocityEvent = detail;
        }

        let {
          temperatura_min,
          temperatura_max,
          humedad_min,
          humedad_max,
          temperaturas,
          humedades,
        } = extractTemperatureAndHumidityData(data.mensaje_alerta, this.eventData.evento);

        let {
          sensor,valor, valorLimite
        } = extractSingleTemperatureAndHumidityData(data.mensaje_alerta, this.eventData);

        // en cada objeto tengra, temperatura, sensor (string), y temperatura min y max igualmente para humedda
        return {
          id_event: data.uuid_event,
          slug_event: data.evento,
          driverId: data.parametros.driverId,
          event_driverId : data.driver_id,
          canIdentifyDriverEvent: this.driverIdentificationService.canIdentifyDriverEvent(data.evento),
          // para alertas de temperatura y humedad
          temperaturas,
          humedades,
          sensor,
          valor,
          valorLimite,

          temperatura_max,
          temperatura_min,
          humedad_max,
          humedad_min,
          fecha_no_autorizada: data.fecha_no_autorizada,

          name_event_long: data.name,
          name_event_short: data.nombre,
          name_unit: data.nombre_objeto || 'Sin Nombre',
          name_driver: data.name_driver,
          longitude_event: data.longitud,
          latitude_event: data.latitud,
          url_google_maps: `https://www.google.com/maps/search/?api=1&query=${data.latitud},${data.longitud}&amp;t=m`,
          date_event: data.fecha_tracker,
          speed_unit: data.velocidad || data.velocidad_unidad || 0,
          limit_speed_unit: data.velocidad_limite,
          geocerca: data.nombre_zona || data.geocerca,
          reference_event: data.referencia,
          type_event: data.tipo,
          time_limit_infraction: data.tiempo_limite_infraccion,
          componentRef: data.componentRef,

          luminaria: data.luminaria,
          last_maintenance:
            data.int_mant_ultimo_mantenimiento || data.ultimo_mantenimiento,
          hours_passed: data.int_mant_horas_transcurridas,
          hours_remaining: data.int_mant_horas_restantes,
          odometer: data.int_mant_odometro,
          rpm: data.rpm,
          time_tolerance: data.tiempo_tolerancia,
          voltage: data.voltaje,
          time_estadia: data.tiempo_estadia,
          alcohol_level: data.alcoholLevel,
          server_date: data.fecha_servidor,
          status_camera: statusCamera,
          status_system_error: statusSystemError,
          status_system_ok: statusSystemOk,
          status_system_boot_failure: statusSystemBootFailure,

          evaluations_criteria_filter: data.evaluation_criteria_filter,
          evaluations: data.evaluations,
          operators: data.operators,
          hasEventForm: data.bol_evaluation,
        } as EventContent;
      })
    );

    this.auxDisabled$ = mapAsideService.auxDisabled$.pipe(
      distinctUntilChanged((prev, curr) => prev === curr),
      tap((_) => {
        this.auxDisabled = _;
        cdr.detectChanges();
      })
    );

    this.errorServer$ = mapAsideService.errorServer$;

    this.valueInputsDisabled$ = mapAsideService.valueInputsDisabled$.pipe(
      tap((_) => {
        this.valueRaiting = _?.calification || null;
        cdr.detectChanges();
      })
    );

    this.isLoading$ = mapAsideService.isLoading$.pipe(
      tap((loading) => {
        if (!loading) {
          this.isActiveCriteria = false;
          this.isActiveUrl = false;
          this.isActiveCalification = false;
          this.isActiveObservation = false;
          this.isActiveOperator = false;
        }
        cdr.detectChanges();
      })
    );

    this.isMaximized$ = mapAsideService.isMaximized$.pipe(
      tap((isMaximized) => {
        this.isMaximizedAux = isMaximized;
        cdr.detectChanges();
      })
    );

    this.messagesSentByWhatsApp$ = mapAsideService.messagesSentByWhatsApp$.pipe(
      tap((messages: WhatsAppResponse[] | null) => {
        if (messages !== null) {
          let messagesAux: Record<string, (T: WhatsAppResponse[]) => string> = {
            false: (T) => {
              if (T.length > 0) {
                return 'Algunos mensajes de WhatsApp no se enviaron.';
              } else {
                return ''; // 'No se enviaron mensajes de WhatsApp.';
              }
            },
            true: (T) => 'Los mensajes de WhatsApp se enviaron correctamente.',
          };
          this.messagesSentByWhatsApp = messages;
          this.whatsappsSendingMessage =
            messagesAux[`${this.areMessagesSentCorrectly()}`](messages);
          this.isLoadingMessages = false;
          this.variantMessage = this.getStatusMessagesSentByWhatsApp();
          cdr.detectChanges();
        }
      })
    );

    this.driverIdentificationService.driverId$
      .pipe(takeUntil(this.destroy$))
      .subscribe((driverId) => {
        // Mantener null si no hay valor
        this.driverIdentificationId = Number(driverId) || 0;
    });
  }

  onDriverIdentificationChange(driverId: any) {
    this.driverIdentificationService.selectDriverById(driverId)
  }

  findDriverAside() {
    let eventData = this.mapAsideService.getData();
    this.driverIdentificationService.openDriverIdentificationPanel(eventData);
  }

  getDurationText(totalSeconds: number): string {
    if (totalSeconds == null || totalSeconds < 0) {
      return '';
    }

    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    const parts: string[] = [];

    if (minutes > 0) {
      parts.push(`${minutes} minuto${minutes !== 1 ? 's' : ''}`);
    }

    if (seconds > 0 || minutes === 0) {
      parts.push(`${seconds} segundo${seconds !== 1 ? 's' : ''}`);
    }

    return parts.join(' ');
  }

  showDriverWarning = false;

  driverIdIdentification$ = this.driverIdentificationService.driverId$;

  onCheckboxClick(driverId: string | number, event: MouseEvent) {
    const currentDriverId = this.driverIdentificationService.driverIdSubject.getValue();
    const drivers = this.driverIdentificationService.getDriversValue();
    const driverFromEvent = drivers.find(d => d.fromEvent);

    // Caso: ya hay un driver seleccionado
    if (currentDriverId) {
      // Si es el mismo → reset
      if (currentDriverId === driverId) {
        this.driverIdentificationService.resetDriverId();
        this.showDriverWarning = false;
        return;
      }

      // Si es diferente → intentar usar driver del evento
      if (driverFromEvent) {
        this.driverIdentificationService.selectDriver(driverFromEvent);
        return;
      }

      // Si no hay driver válido → bloquear
      event.preventDefault();
      this.showDriverWarning = true;
      return;
    }

    // Caso: no hay driver seleccionado
    if (driverFromEvent) {
      this.driverIdentificationService.selectDriver(driverFromEvent);
      return;
    }

    // Caso fallback
    event.preventDefault();
    this.showDriverWarning = true;
  }

  private tryMountComponent() {
    // Primero intentamos obtener el contenedor
    this.divContainer = document.getElementById(
      'multimedia-aside-map-' + this.idEvent
    );

    if (this.divContainer) {
      // Si existe el contenedor, montamos el componente
      this.mountComponent();
    } else {
      // Si no existe, configuramos un observer para esperar a que exista
      this.waitForContainer();
    }
  }

  private waitForContainer() {
    // Creamos un observer para detectar cambios en el DOM
    const observer = new MutationObserver((mutations, obs) => {
      this.divContainer = document.getElementById(
        'multimedia-aside-map-' + this.idEvent
      );

      if (this.divContainer) {
        // Si encontramos el contenedor, detenemos el observer y montamos el componente
        obs.disconnect();
        this.mountComponent();
      }
    });

    // Configuramos el observer para observar cambios en el body
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Como respaldo, también configuramos un timeout para detener el observer
    setTimeout(() => observer.disconnect(), 5000);
  }

  private mountComponent() {
    if (this.componentRef && this.divContainer) {
      this.divContainer.innerHTML = '';
      this.divContainer.appendChild(this.componentRef.location.nativeElement);
      this.componentRef.changeDetectorRef.detectChanges();
      this.cdr.detectChanges();
      // setTimeout(() => {
      //   if (
      //     this.componentRef.instance?.getMultimediaByRangeSpecificPublic &&
      //     this.eventData?.fecha_tracker
      //   ) {
      //     if(
      //       this.eventService.videoDemandInEvents[this.eventData.evento]
      //     ) {
      //       this.componentRef.instance.getMultimediaByRangeSpecificPublic(
      //         this.eventData.fecha_tracker,10
      //       )
      //     }
      //   }
      // });
    }
  }

  ngOnInit(): void {
    if (!this.driversService.drivers || this.driversService.drivers.length === 0) {
      this.driversService.getAll();
    }
    // Si ya tenemos componentRef al inicio, intentamos montar
    if (this.componentRef) {
      this.tryMountComponent();
    }
    this.nameOperatorLocalStorage =
      localStorage.getItem('monitoringOperator') || '';

    this.loadObservations()
    this.checklistSub = this.checklistEventService.checklistEvents$.subscribe((checklists) => {
      // console.log("checklist : event content checklsit body")
      if (this.eventData && this.eventData.evento == 'checklist-daily') {
        const newDetail = checklists[this.eventData.uuid_event];
        // console.log("checklist : update event selecte from event", this.eventData.uuid_event)
        if (newDetail && this.checklistDetail != newDetail) {
          // console.log("checklist : update event contentnt checklist", newDetail)
          // Solo asignar si newDetail no es undefined
          if (this.checklistDetail) {
            Object.assign(this.checklistDetail, newDetail);
          } else {
            this.checklistDetail = { ...newDetail };
          }
          // console.log("event content : update value checklsit", this.checklistDetail)
          this.cdr.detectChanges();
        }
      }
    }
    );
  }

  ngAfterViewInit(): void {
    this.isSecondCardActive = true;
    // Si tenemos componentRef después de la vista inicial, intentamos montar
    if (this.componentRef) {
      this.tryMountComponent();
    }
    this.cdr.detectChanges();
  }

  getClassByEvent(type: string, nombre: string, slug?: string): string {
    if (slug && slug == 'checklist-daily') {
      return this.checklistDetail?.clase || 'checklist-waiting';
    }
    if (
      ['exceso-velocidad-nivel', 'exceso-velocidad-nivel-direccion'].includes(
        type
      )
    ) {
      const lvlss = [
        { value: 'Nivel III', lvl: '-lvl3' },
        { value: 'Nivel II', lvl: '-lvl2' },
        { value: 'Nivel I', lvl: '-lvl1' },
      ];
      const _lvl = lvlss.find((lvl) => nombre.includes(lvl.value));
      if (_lvl) {
        type += _lvl.lvl;
      }
    }
    return (
      this.eventService.eventsClassList.find(
        (eventClass: any) => eventClass.tipo == type
      )?.clase ?? 'default-event'
    );
  }

  fabricNameEvent(type: string, nameLong: string, slug?: string) {
    if (slug && slug == 'checklist-daily') {
      return this.checklistDetail?.clase === 'checklist-completed'
        ? 'CL Completado'
        : this.checklistDetail?.clase === 'checklist-no-completed'
          ? 'CL No Completado'
          : this.checklistDetail?.clase === 'checklist-danger'
            ? 'CL con observaciones'
            : this.checklistDetail?.clase === 'checklist-waiting'
              ? 'CL en proceso'
              : 'Estado desconocido';
    }
    if (type.toLowerCase().includes('lvl')) {
      const level = type.match(/lvl(\d)/i)?.[1];
      if (level) {
        return `${nameLong} - Nivel ${'I'.repeat(parseInt(level))}`;
      }
    }

    return nameLong;
  }

  msmOfTxRadialChange(event: any) {
    const value = event.value;
    if (value == null) this.msmOfTxRadial = 'Sin respuesta';
    if (value == true) this.msmOfTxRadial = 'Si';
    if (value == false) this.msmOfTxRadial = 'No';
  }
  msmOfTxRadialSelect(value: boolean | null | undefined): string {
    let message = 'Sin respuesta';
    if (value == null) message = 'Sin respuesta';
    if (value == true) message = 'Si';
    if (value == false) message = 'No';
    return message;
  }

  private checkEvent: string[] = [
    'exceso-velocidad',
    'infraccion-geocerca-direccion',
    'infraccion-geocerca',
    'exceso-velocidad-geocerca-direccion',
    'conductor-somnoliento-360',
    'conductor-adormitado-360',
    'posible-fatiga',
  ];
  checkListEventsByType(type: string) {
    return this.checkEvent.includes(type);
  }

  criteriaSelected(event: any) {
    this.sendEvaluationByWhatsapp = false;
    this.sendExternal = false;
    this.submitSendEvaluationByWhatsappEmitter();
    this.submitSendExternalEmitter();

    const value = event.value;
    this.isConfirmedEvaluation =
      this.evaluationCriteriaService.isCriteriaConfirmed(value);
    this.senalesPosibleFatigaAux =
      this.evaluationCriteriaService.isPosibleFatiga(value);

    const typeEventV2 = this.evaluationsAux[0].tipo_evento || undefined;
    if (typeEventV2 && typeEventV2 != 'Posible Fatiga') {
      /* let itemSelected = '';
      this.criteriaEvaluations.forEach(
        (criteria) =>
          (itemSelected =
            criteria.items.find(
              (item) =>
                item.value.toString() === this.criteria_input?.toString()
            )?.label || '')
      );


      this.criteriaEvaluations[0].items.some((c, i) => {
        if (i < 2 && c.label == itemSelected) {
          this.confirmedJudgingEvent = true;
          return true;
        }
        this.confirmedJudgingEvent = false;
        return false;
      }); */
      this.confirmedJudgingEvent = this.isConfirmedEvaluation;
    }
  }

  public criteria_input: number | undefined;
  public urlvideo_input: string | undefined;
  public calification_input: number | undefined;
  public observation_input: string | undefined;
  public operator_name_input: string | undefined;

  private eventSelected: any;

  public errorCriteria: ErrorMessage = { status: false, message: '' };
  public errorUrl: ErrorMessage = { status: false, message: '' };
  public errorCalification: ErrorMessage = { status: false, message: '' };
  public errorObservation: ErrorMessage = { status: false, message: '' };
  public errorOperator: ErrorMessage = { status: false, message: '' };

  public isLoadingMessages: boolean = false;
  public variantMessage: string = 'default';

  async submitEvaluation(event: EventContent) {
    const validationResult = this.validateEvaluationForm();

    // Update error states
    this.errorCriteria = {
      status: !!validationResult.errors.criteria,
      message: validationResult.errors.criteria || '',
    };

    this.errorUrl = {
      status: !!validationResult.errors.url,
      message: validationResult.errors.url || '',
    };

    this.errorCalification = {
      status: !!validationResult.errors.calification,
      message: validationResult.errors.calification || '',
    };

    this.errorObservation = {
      status: !!validationResult.errors.observation,
      message: validationResult.errors.observation || '',
    };

    this.errorOperator = {
      status: !!validationResult.errors.operator,
      message: validationResult.errors.operator || '',
    };

    // If form is valid, proceed with submission
    if (validationResult.isValid) {
      // Proceed with your form submission logic here
      // console.log('Form is valid, proceeding with submission');
      this.isLoadingMessages = true;
      this.variantMessage = 'loading';
      this.cdr.detectChanges();
      this.mapAsideService.setIsLoading(true);
      let itemSelected = '';
      this.criteriaEvaluations.forEach(
        (criteria) =>
        (itemSelected =
          criteria.items.find(
            (item) =>
              item.value?.toString() === this.criteria_input?.toString()
          )?.label || itemSelected)
      );

      let identification = {}
      let hasAccess = await this.permissionService.hasPermission('validate_event_driver');
      if(hasAccess && this.driverIdentificationService.canIdentifyDriverEvent(event.slug_event || "")){
        identification = {
          new_driver_id : this.driverIdentificationId.toString(),
          param_event_id : this.eventSelected.parametros?.eventId || "",
          origin_driver : this.driverIdentificationService.getDriverOriginById(this.driverIdentificationId.toString() || "")
        }
      }

      const evaluations = cloneDeep({
        ...event.evaluations,
        is_confirmed: this.isConfirmedEvaluation,
        ...identification,
        criterio_evaluacion: itemSelected,
        criterio_id: this.criteria_input,
        criterion_id: this.criteria_input,
        has_radio_comunication: this.radioValue,
        has_radio_communication: this.radioValue,
        identificacion_video: this.urlvideo_input || '',
        observacion_evaluacion: this.observation_input,
        operador_monitoreo: this.operator_name_input,
        valoracion_evento: this.calification_input
          ? this.calification_input?.toString()
          : '',
        senales_posible_fatiga: this.senalesPosibleFatigaAux || false,
      });
      const newEvent: any = cloneDeep({
        ...this.eventSelected,
        evaluations: [evaluations],
      });

      localStorage.setItem(
        'monitoringOperator',
        this.operator_name_input || ''
      );
      this.saveInLocalStorageObservation();

      this.mapAsideService.setSubmitFormEventContent(evaluations, {
        ...newEvent,
        originPopup: this.originPopup,
      });
    } else {
      // console.log('Form validation failed');
    }
  }

  saveInLocalStorageObservation() {
    if (!this.observation_input?.trim()) return;

    const key = 'observationsLocal';
    const stored = JSON.parse(localStorage.getItem(key) || '[]') as string[];

    const filtered = stored.filter((obs) => obs !== this.observation_input);
    const updated = [...filtered, this.observation_input];

    if (updated.length > 5) {
      updated.shift(); // eliminamos el primero (el más viejo)
    }

    localStorage.setItem(key, JSON.stringify(updated));
  }

  loadObservations() {
    this.observations = JSON.parse(
      localStorage.getItem('observationsLocal') || '[]'
    );
  }

  private validateEvaluationForm(): FormValidationResult {
    const result: FormValidationResult = {
      isValid: true,
      errors: {},
    };

    // Validar criterio
    this.isActiveCriteria = true;
    if (this.isCriteria) {
      const criteriaError = FormFieldValidators.validateCriteria(
        this.criteria_input
      );
      if (criteriaError.status) {
        result.isValid = false;
        result.errors.criteria = criteriaError.message;

        // Validar observación
        this.isActiveObservation = true;
        const observationError = FormFieldValidators.validateObservation(
          this.observation_input
        );

        if (observationError.status) {
          result.isValid = false;
          result.errors.observation = observationError.message;
        } else {
          result.isValid = true;
          result.errors.criteria = '';
        }
      }
    } else {
      this.isActiveCriteria = false;
      this.isActiveObservation = true;
      const observationError = FormFieldValidators.validateObservation(
        this.observation_input
      );

      if (observationError.status) {
        result.isValid = false;
        result.errors.observation = observationError.message;
      }
    }

    // Validar URL y calificación si es evaluación confirmada
    if (this.isConfirmedEvaluation) {
      this.isActiveUrl = true;
      /* const urlError = FormFieldValidators.validateUrl(
        this.urlvideo_input,
        this.isConfirmedEvaluation
      );
      if (urlError.status) {
        result.isValid = false;
        result.errors.url = urlError.message;
      } */

      this.isActiveCalification = true;
      // const calificationError = FormFieldValidators.validateCalification(
      //   this.calification_input,
      //   this.isConfirmedEvaluation
      // );
      // if (calificationError.status) {
      //   result.isValid = false;
      //   result.errors.calification = calificationError.message;
      // }
    }

    // Validar operador
    this.isActiveOperator = true;
    const operatorError = FormFieldValidators.validateOperator(
      this.operator_name_input
    );
    if (operatorError.status) {
      result.isValid = false;
      result.errors.operator = operatorError.message;
    }

    return result;
  }

  public isActiveCriteria = false;
  public isActiveUrl = false;
  public isActiveCalification = false;
  public isActiveObservation = false;
  public isActiveOperator = false;

  onCriteriaChange(): void {
    this.isActiveCriteria = true;
    this.errorCriteria = FormFieldValidators.validateCriteria(
      this.criteria_input
    );
  }

  onUrlChange(): void {
    this.isActiveUrl = true;
    /* this.errorUrl = FormFieldValidators.validateUrl(
      this.urlvideo_input,
      this.isConfirmedEvaluation
    ); */
  }

  onCalificationChange(): void {
    this.isActiveCalification = true;
    // this.errorCalification = FormFieldValidators.validateCalification(
    //   this.calification_input,
    //   this.isConfirmedEvaluation
    // );
  }

  onObservationChange(): void {
    this.isActiveObservation = true;
    this.errorObservation = FormFieldValidators.validateObservation(
      this.observation_input
    );
  }

  disableActiveObservation() {
    this.isActiveObservation = false;
  }

  onOperatorChange(): void {
    this.isActiveOperator = true;
    this.errorOperator = FormFieldValidators.validateOperator(
      this.operator_name_input
    );
  }

  clearForm() {
    // disabled style in borders for the inputs
    this.isActiveCriteria = false;
    this.isActiveUrl = false;
    this.isActiveCalification = false;
    this.isActiveObservation = false;
    this.isActiveOperator = false;

    // clear the values in the inputs
    this.criteria_input = undefined;
    this.urlvideo_input = undefined;
    this.calification_input = undefined;
    this.observation_input = undefined;
    this.operator_name_input = undefined;

    // disabeld the state in the errors
    this.errorCriteria = { status: false, message: '' };
    this.errorUrl = { status: false, message: '' };
    this.errorCalification = { status: false, message: '' };
    this.errorObservation = { status: false, message: '' };
    this.errorOperator = { status: false, message: '' };

    // var independent
    this.radioValue = this.originRadioComunitacion;
    this.msmOfTxRadial = this.msmOfTxRadialSelect(this.originRadioComunitacion);
    this.isConfirmedEvaluation = false;
    this.imeiBelongsToAntapaccayAccount = false;
    this.confirmedJudgingEvent = false;
    this.senalesPosibleFatigaAux = false;
  }

  closeCardSecondary() {
    this.isSecondCardActive = false;
  }

  public sendEvaluationByWhatsapp: boolean = false;
  public sendExternal: boolean = false;

  submitSendEvaluationByWhatsappEmitter() {
    this.mapAsideService.setSendEvaluationByWhatsapp(
      this.sendEvaluationByWhatsapp
    );
  }

  submitSendExternalEmitter() {
    this.mapAsideService.setSendExternal(this.sendExternal);
  }
  // ingresamos a la decadencia
  iCanSeeWhatsappSending(): boolean {
    if (this.eventIdAux != null) {
      // chequeo seguro que no sea null ni undefined
      const a: any = this.alertService.getAlertById(this.eventIdAux.toString());
      if (
        a &&
        a.notificacion_whatsapp &&
        this.checkBoolean(a.notificacion_whatsapp) &&
        this.imeiBelongsToAntapaccayAccount &&
        this.confirmedJudgingEvent
      ) {
        return true;
      }
    }
    return false;
  }

  private checkBoolean(input: string | number | boolean): boolean {
    if (typeof input === 'boolean') {
      return input;
    }
    const booleanValues: Record<string, boolean> = {
      true: true,
      false: false,
      '1': true,
      '0': false,
    };
    if (typeof input === 'number') {
      return booleanValues[input.toString()] ?? false;
    }
    if (typeof input === 'string') {
      const trimmedInput = input.trim().toLowerCase();
      return booleanValues[trimmedInput] ?? false;
    }
    return false;
  }
  iCanSeeExternalSending(): boolean {
    let res: boolean = false;
    if (this.eventIdAux != null) {
      const alertId = this.eventIdAux.toString();
      const a: any = this.alertService.getAlertById(alertId);
      if (
        a &&
        this.imeiBelongsToAntapaccayAccount &&
        this.confirmedJudgingEvent
      ) {
        res = true;
      }
    }
    return res;
  }

  private vehicleIsFromAntapaccay(imei: string) {
    this.imeiBelongsToAntapaccayAccount =
      this.whatsappService.IMEIsBelongsToAntapaccayAccount.some(
        (_: string) => _ == imei
      );
  }

  private keyboardSubscription$ = new Subject<boolean>();

  setupKeyboardShortcuts() {
    fromEvent<KeyboardEvent>(document, 'keydown')
      .pipe(
        filter((event) => {
          const isInputSelected =
            event.target instanceof HTMLInputElement ||
            event.target instanceof HTMLTextAreaElement;

          const isKeyI = event.key.toLowerCase() === 'i';
          return !isInputSelected && isKeyI;
        }),
        takeUntil(this.keyboardSubscription$),
        takeUntil(this.destroy$)
      )
      .subscribe((event) => {
        event.preventDefault(); // Prevenir la búsqueda por defecto del navegador
        const currentState = this.isMaximizedAux;
        this.mapAsideService.setIsMaximized(!currentState);
      });
  }

  private keyboardNextAndPreviousSubscription$ = new Subject<boolean>();

  setupKeyboardShortcutsNextAndPrevious() {
    fromEvent<KeyboardEvent>(document, 'keydown')
      .pipe(
        filter((event) => {
          const isCmdOrCtrl = event.ctrlKey || event.metaKey;
          const isArrowWithModifier =
            isCmdOrCtrl &&
            (event.key === 'ArrowLeft' || event.key === 'ArrowRight');
          return isArrowWithModifier;
        }),
        takeUntil(this.keyboardNextAndPreviousSubscription$),
        takeUntil(this.destroy$)
      )
      .subscribe((event) => {
        event.preventDefault();
        // this.driverIdentificationService.reset()
        if (event.key === 'ArrowLeft') {
          this.previousEvent();
        } else if (event.key === 'ArrowRight') {
          this.nextEvent();
        }
      });
    /*  .subscribe({
        next: (event) => {
          event.preventDefault();
          if (event.key === 'ArrowLeft') {
            this.previousEvent();
          } else if (event.key === 'ArrowRight') {
            this.nextEvent();
          }
        },
        error: (error) => console.error('Error en la suscripción:', error),
      }); */
  }

  handleComponentRefChange(data: any) {
    if (data.componentRef === null) {
      this.mapAsideService.setIsMaximized(false);
      // Cancelar la suscripción del teclado
      this.keyboardSubscription$.next(true);
    } else {
      // Iniciar nueva suscripción
      this.keyboardSubscription$.next(false);
      this.setupKeyboardShortcuts();
    }
  }

  normalizeArrayEvaluations(evaluations: OptionDropdown[]) {
    if (!this.evaluationsAux?.length) {
      return normalizeArrayEvaluations(evaluations, false);
    }
    try {
      const typeEventV2 = this.evaluationsAux[0]?.tipo_evento;
      let isActive = false;

      if (typeEventV2 && typeEventV2 !== 'Posible Fatiga') {
        isActive = true;
      }

      return normalizeArrayEvaluations(evaluations, isActive);
    } catch (error) {
      console.warn('Error al procesar evaluationsAux:', error);
      return normalizeArrayEvaluations(evaluations, false);
    }
  }

  getStatusMessagesSentByWhatsApp(): string {
    if (this.isLoadingMessages) {
      return 'loading';
    }
    if (this.areMessagesSentCorrectly()) {
      return 'success';
    }
    if (this.messagesSentByWhatsApp.length > 0) {
      return 'warning';
    }
    return 'error';
  }

  public whatsappsSendingMessage: string = '';
  public messagesSentByWhatsApp: WhatsAppResponse[] = [];

  messageSendingMessage(usuario_id: string, uuid_event: string) {
    if (!usuario_id || !uuid_event) {
      console.warn(
        'messageSendingMessage: usuario_id or uuid_event is missing'
      );
      return;
    }

    let messages: Record<string, (T: WhatsAppResponse[]) => string> = {
      false: (T) => {
        if (T.length > 0) {
          return 'Algunos mensajes de WhatsApp no se enviaron.';
        } else {
          return ''; // 'No se enviaron mensajes de WhatsApp.';
        }
      },
      true: (T) => 'Los mensajes de WhatsApp se enviaron correctamente.',
    };

    this.whatsappService
      .getMessagesSentByWhatsApp(usuario_id, uuid_event)
      .then((r) => {
        this.messagesSentByWhatsApp = r;
        this.whatsappsSendingMessage =
          messages[`${this.areMessagesSentCorrectly()}`](r);
        if (this.auxDisabled) {
          this.mapAsideService.setMessagesSentByWhatsApp(r);
        }
        this.cdr.detectChanges();
      });
  }

  areMessagesSentCorrectly(): boolean {
    return this.messagesSentByWhatsApp.some((r) => r.status == 200);
  }

  copyValue(event: Event | undefined, value: string): void {
    event?.stopPropagation();
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(value)
        .then(() => { })
        .catch((err) => {
          console.error('Error al copiar al portapapeles: ', err);
        });
    } else {
      console.warn('El portapapeles no está soportado en este navegador');
    }
  }

  formatTimeWithUnit(input: string) {
    return formatTimeWithUnit(input);
  }

  previousEvent() {
    this.mapAsideService.getPreviousEventPublic();
  }

  nextEvent() {
    this.mapAsideService.getNextEventPublic();
  }

  getDescriptionCamera(status_camera: string | undefined): string | undefined {
    if (!status_camera) return undefined;

    switch (status_camera.toLowerCase()) {
      case 'cabin camera is blurred':
        return 'La cámara de cabina presenta imagen borrosa';
      case 'cabin camera is working':
        return 'La cámara de cabina está operando correctamente';
      case 'cabin camera is over exposure':
        return 'La cámara de cabina detecta sobreexposición de luz';
      case 'cabin camera is unrecognized':
        return 'No se reconoce la cámara de cabina';
      case 'road camera blocked':
        return 'Cámara de carretera bloqueada';
      default:
        return undefined;
    }
  }

  getDescriptionSystemBootFailure(
    status_system: string | undefined
  ): string | undefined {
    if (!status_system) return undefined;

    switch (status_system.toLowerCase()) {
      case 'gps failed':
        return 'GPS fallido';
      case 'wi-fi failed':
        return 'Wi-Fi fallido';
      case 'emmc failed':
        return 'eMMC fallida (memoria interna)';
      case 'bt failed':
        return 'Bluetooth fallido';
      case 'g-sensor failed':
        return 'Sensor G fallido';
      default:
        return undefined;
    }
  }

  getDescriptionSystemError(
    status_system: string | undefined
  ): string | undefined {
    if (!status_system) return undefined;

    switch (status_system.toLowerCase()) {
      case 'sdcard error':
        return 'Error en la tarjeta SD';
      case 'camera_failure':
        return 'Falla en la cámara';
      case 'over_exposure':
        return 'Sobreexposición de imagen';
      case 'dark_image':
        return 'Imagen oscura';
      case 'unrecognized':
        return 'No reconocido';
      case 'damaged_led':
        return 'LED dañado';
      case 'devicenotcalibrated':
        return 'Dispositivo no calibrado';
      case 'hwmalfunction-camera':
        return 'Mal funcionamiento de hardware - cámara';
      case 'powerlost':
        return 'Pérdida de energía';
      case 'mcuoverheat':
        return 'Sobrecalentamiento del MCU';
      case 'mcu version error':
        return 'Error de versión del MCU';
      case 'mcu version ap or hw number error':
        return 'Error de versión AP o número HW del MCU';
      case 'cpuoverheat':
        return 'Sobrecalentamiento del CPU';
      case 'imagesensoroverheat':
        return 'Sobrecalentamiento del sensor de imagen';
      case 'invalidconfigrejected':
        return 'Configuración inválida rechazada';
      case 'roadcamera not connected':
        return 'Cámara de carretera no conectada';
      default:
        return undefined;
    }
  }

  getDescriptionSystemOk(
    status_system: string | undefined
  ): string | undefined {
    if (!status_system) return undefined;

    switch (status_system.toLowerCase()) {
      case 'camera is working':
        return 'La cámara está funcionando';
      case 'mcuoverheat':
        return 'Sobrecalentamiento del MCU resuelto';
      case 'cpuoverheat':
        return 'Sobrecalentamiento del CPU resuelto';
      case 'imagesensoroverheat':
        return 'Sobrecalentamiento del sensor de imagen resuelto';
      case 'configfilerecovery':
        return 'Recuperación del archivo de configuración exitosa';
      default:
        return undefined;
    }
  }

  ngOnDestroy() {
    this.keyboardNextAndPreviousSubscription$.next(true);
    this.keyboardNextAndPreviousSubscription$.complete();
    this.destroy$.next();
    this.destroy$.complete();
    console.log("liminar checklsit syb", this.checklistSub)
    this.checklistSub?.unsubscribe();
  }

  formatPeruDate(dateIso: string): string {
    if (!dateIso) return '';

    // Convertir a hora de Perú
    const peru = new Date(
      new Date(dateIso).toLocaleString('en-US', { timeZone: 'America/Lima' })
    );

    const yyyy = peru.getFullYear();
    const mm = String(peru.getMonth() + 1).padStart(2, '0');
    const dd = String(peru.getDate()).padStart(2, '0');

    const hh = String(peru.getHours()).padStart(2, '0');
    const min = String(peru.getMinutes()).padStart(2, '0');
    const ss = String(peru.getSeconds()).padStart(2, '0');

    return `${yyyy}/${mm}/${dd} ${hh}:${min}:${ss}`;
  }
}
